import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Alert, AlertTitle} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@mui/material';
import useClasses from '../../../helpers/useClasses';


const styles = theme => ({
  root: {
    borderRadius: '0px',
    color: '#fff'
  }
});

const MessageBar = props => {
  const { severity, title, richContent, message, ...rest } = props;

  const classes = useClasses(styles);

  return (
    richContent ? 
      <Alert
        variant="filled"
        color={severity}
        severity={severity}
        // classes={classes}
        sx={{
          borderRadius: '0px',
          color: '#fff'
        }}
        {...rest}
      >
        {title ?
        <AlertTitle
          sx={{color: '#fff'}}  
        >{title}</AlertTitle>
        : null}
        <div>
          DataMerch Pro membership with our merchant subscriptions tool is now available! See the 
          <RouterLink to="/pro" target="_blank">
            <Button
              className={classes.button}
              sx={{color: '#263238'}}
            >
              video
            </Button>
          </RouterLink>
           and instructions to upgrade and activate merchant subscriptions 
           <RouterLink to="/docs/Merchant_subscriptions_directions.pdf" target="_blank">
            <Button
              className={classes.button}
              sx={{color: '#263238'}}
            >
              here
            </Button>
          </RouterLink>.
        </div>
      </Alert>
      : <Alert
        variant="filled"
        color={severity}
        severity={severity}
        classes={classes}
        {...rest}
      >
        {title ?
        <AlertTitle classes={classes} sx={{
          color: '#fff'
        }}>{title}</AlertTitle>
        : null}
        {message}
      </Alert>
    
    
    // <Alert
    //   variant="filled"
    //   color={severity}
    //   severity={severity}
    //   classes={classes}
    //   {...rest}
    // >
    //   {title ?
    //   <AlertTitle classes={classes}>{title}</AlertTitle>
    //   : null}
    //   {richContent ?
    //   <div>
    //     <AlertTitle classes={classes}>{title}</AlertTitle>
    //   </div>
    //   : null}
    //   {message}
    // </Alert>
  );
};

MessageBar.propTypes = {
  severity: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string
};

export default MessageBar;
